/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-08-19 10:03:52
 * @LastEditors: lwq
 * @LastEditTime: 2021-04-15 09:59:31
 * @FilePath: \web_admin\src\service\api\forgot-password.js
 */
import http from "../httpConfig"
const table = "mrbase_sys_users"
// 保存新密码
export const savePwd = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/personalcenter/save-newpwd/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const sendEmail = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/personalcenter/send-updatePwdEmail/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 验证token过期
export const checkToken = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/personalcenter/check-token/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 修改密码

export const updatePassword = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/personalcenter/save-updatepwd/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 获取密码强度的正则
export const passwordStrength = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/personalcenter/return-security/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 修改员工头像
export const updateAvatar = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/staff-manager/upload_staff_avatar/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
